const STRAPI_URL =
	process.env.STRAPI_API_URL ||
	'https://wilaustralia-55061f853444.herokuapp.com';

export const authAPI = {
	// Get member institutes for registration
	async getMemberInstitutes() {
		try {
			const response = await fetch(`${STRAPI_URL}/api/auth/member-institutes`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
				},
			});

			const data = await response.json();

			if (!response.ok) {
				throw new Error(
					data.error?.message ||
						`HTTP ${response.status}: ${response.statusText}`
				);
			}

			return data;
		} catch (error) {
			console.error('Get member institutes API Error:', error);
			throw error;
		}
	},

	// Join/Register (legacy - keeping for backward compatibility)
	async join(userData) {
		try {
			const response = await fetch(`${STRAPI_URL}/api/auth/register`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(userData),
			});

			const data = await response.json();

			if (!response.ok) {
				throw new Error(
					data.error?.message ||
						`HTTP ${response.status}: ${response.statusText}`
				);
			}

			return data;
		} catch (error) {
			console.error('API Error:', error);
			throw error;
		}
	},

	// Request to Join (new simplified flow)
	async requestJoin(joinData) {
		try {
			const response = await fetch(`${STRAPI_URL}/api/auth/request-join`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(joinData),
			});

			const data = await response.json();

			if (!response.ok) {
				throw new Error(
					data.error?.message ||
						`HTTP ${response.status}: ${response.statusText}`
				);
			}

			return data;
		} catch (error) {
			console.error('Request Join API Error:', error);
			throw error;
		}
	},

	// Validate email domain
	async validateDomain(email) {
		try {
			const response = await fetch(`${STRAPI_URL}/api/auth/validate-domain`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ email }),
			});

			const data = await response.json();

			if (!response.ok) {
				throw new Error(
					data.error?.message ||
						`HTTP ${response.status}: ${response.statusText}`
				);
			}

			return data;
		} catch (error) {
			console.error('Domain validation API Error:', error);
			throw error;
		}
	},

	// Check user status for login flow
	async checkUserStatus(email) {
		try {
			const response = await fetch(`${STRAPI_URL}/api/auth/check-user-status`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ email }),
			});

			const data = await response.json();

			if (!response.ok) {
				throw new Error(
					data.error?.message ||
						`HTTP ${response.status}: ${response.statusText}`
				);
			}

			return data;
		} catch (error) {
			console.error('Check user status API Error:', error);
			throw error;
		}
	},

	// Setup password for user
	async setupPassword(email, password) {
		try {
			const response = await fetch(`${STRAPI_URL}/api/auth/setup-password`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ email, password }),
			});

			const data = await response.json();

			if (!response.ok) {
				throw new Error(
					data.error?.message ||
						`HTTP ${response.status}: ${response.statusText}`
				);
			}

			return data;
		} catch (error) {
			console.error('Setup password API Error:', error);
			throw error;
		}
	},

	// Setup 2FA for user
	async setup2FA(email) {
		try {
			const response = await fetch(`${STRAPI_URL}/api/auth/setup-2fa`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ email }),
			});

			const data = await response.json();

			if (!response.ok) {
				throw new Error(
					data.error?.message ||
						`HTTP ${response.status}: ${response.statusText}`
				);
			}

			return data;
		} catch (error) {
			console.error('Setup 2FA API Error:', error);
			throw error;
		}
	},

	// Verify 2FA code
	async verify2FA(email, code) {
		try {
			const response = await fetch(`${STRAPI_URL}/api/auth/verify-2fa`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ email, code }),
			});

			const data = await response.json();

			if (!response.ok) {
				throw new Error(
					data.error?.message ||
						`HTTP ${response.status}: ${response.statusText}`
				);
			}

			return data;
		} catch (error) {
			console.error('Verify 2FA API Error:', error);
			throw error;
		}
	},

	// Login with password and 2FA
	async loginWithPassword(email, password, twoFactorCode = null) {
		try {
			const response = await fetch(
				`${STRAPI_URL}/api/auth/login-with-password`,
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({ email, password, twoFactorCode }),
				}
			);

			const data = await response.json();

			if (!response.ok) {
				throw new Error(
					data.error?.message ||
						`HTTP ${response.status}: ${response.statusText}`
				);
			}

			return data;
		} catch (error) {
			console.error('Login with password API Error:', error);
			throw error;
		}
	},

	// Verify password only (without login attempt)
	async verifyPassword(email, password) {
		try {
			const response = await fetch(`${STRAPI_URL}/api/auth/verify-password`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ email, password }),
			});

			const data = await response.json();

			if (!response.ok) {
				throw new Error(
					data.error?.message ||
						`HTTP ${response.status}: ${response.statusText}`
				);
			}

			return data;
		} catch (error) {
			console.error('Verify password API Error:', error);
			throw error;
		}
	},

	// Request login status
	async requestLogin(email) {
		const response = await fetch(`${STRAPI_URL}/api/auth/request-login`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ email }),
		});
		return response.json();
	},

	// Set password
	async setPassword(email, password) {
		try {
			const response = await fetch(`${STRAPI_URL}/api/auth/set-password`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ email, password }),
			});

			const data = await response.json();

			if (!response.ok) {
				throw new Error(
					data.error?.message ||
						`HTTP ${response.status}: ${response.statusText}`
				);
			}

			return data;
		} catch (error) {
			console.error('Set password API Error:', error);
			throw error;
		}
	},

	// Get current user profile
	async getProfile(token) {
		const response = await fetch(`${STRAPI_URL}/api/auth/profile`, {
			headers: {
				Authorization: `Bearer ${token}`,
				'Content-Type': 'application/json',
			},
		});
		return response.json();
	},

	// Update user profile
	async updateProfile(token, profileData) {
		const response = await fetch(`${STRAPI_URL}/api/auth/profile`, {
			method: 'PUT',
			headers: {
				Authorization: `Bearer ${token}`,
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(profileData),
		});
		return response.json();
	},
};
